/* eslint-disable */
import {IDocument} from "../../../modules/ninVerification/types";
import {IPersonProfile} from "../../../app/modules/kyc/person/interfaces/IPersonProfile";

export const STORE_CRM_PERSON_CONSTANTS = {
    workflowsStartFetch: "CRM_PERSON_START_FETCH",
    workflowsStopFetch: "CRM_PERSON_STOP_FETCH",
    workflowsCommitFetch: "CRM_PERSON_COMMIT_FETCH",
    crmPersonReceiveProfile: "CRM_PERSON_RECEIVE_PROFILE",
    personUpdateDocuments: "CRM_PERSON_UPDATE_DOCUMENTS",
    personRawDocuments: "CRM_PERSON_RAW_DOCUMENTS",
    reset: "CRM_PERSON_RESET",
    ToggleDocumentPreviewer: "TOGGLE_DOCUMENT_PREVIEWER"
}

export interface IPersonCrmWorkflowState {
    loading: boolean
    data?: IPersonProfile
    documents?: [],
    openDocumentPreviewer: false,
}

const initialState: IPersonCrmWorkflowState = {
    data: undefined,
    loading: false,
    documents: [],
    openDocumentPreviewer: false,
}

export default function reducer(state = initialState, action: any) {
    switch (action.type) {

        case STORE_CRM_PERSON_CONSTANTS.workflowsStartFetch: {
            return {...state, loading: true}
        }

        case STORE_CRM_PERSON_CONSTANTS.workflowsStopFetch: {
            return {...state, loading: false}
        }

        case STORE_CRM_PERSON_CONSTANTS.workflowsCommitFetch: {
            return {...state, data: action.payload, loading: false}
        }

        case STORE_CRM_PERSON_CONSTANTS.reset: {
            return {...state, data: undefined, loading: false}
        }

        case STORE_CRM_PERSON_CONSTANTS.personUpdateDocuments: {
            return {...state, documents: action.payload}
        }

        case STORE_CRM_PERSON_CONSTANTS.personRawDocuments: {
            return {...state, data: {...state.data, documents: action.payload }}
        }

        case STORE_CRM_PERSON_CONSTANTS.ToggleDocumentPreviewer: {
            return {...state, openDocumentPreviewer: action.payload}
        }

        case STORE_CRM_PERSON_CONSTANTS.crmPersonReceiveProfile: {

            if (state.data && state.data.id === action.payload.id) {
                return {...state, data: action.payload, loading: false}
            }
            return state
        }

        default: {
            return state
        }
    }
}

export function startWorkflowFetch() {
    return {type: STORE_CRM_PERSON_CONSTANTS.workflowsStartFetch}
}